import { useState } from "react";
import { mediaSource } from "../utilities/mediautilities";

const GlobalLoader = () => {
    const [schoolLogo] = useState(localStorage.getItem("school_logo") || null);

    return (
        <>
            {schoolLogo ?
                <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/80">
                    <div className="relative flex items-center justify-center">
                        <span className="absolute inset-0 rounded-full border-4 border-gray animate-[ping_1.4s_ease-out_infinite] opacity-80"></span>

                        <div className="w-[110px] h-[110px] rounded-full flex items-center justify-center p-2 opacity-85">
                            <img
                                src={mediaSource(schoolLogo)}
                                alt="logo"
                                className="max-w-full max-h-full rounded-full object-contain"
                                onError={(e) => mediaSource(e)}
                            />
                        </div>
                    </div>
                </div>
                :
                <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-80">
                    <div className="w-16 h-16 border-4 border-t-blue-500 border-b-blue-500 border-gray-300 rounded-full animate-spin"></div>
                </div>
            }
        </>
    )
}

export default GlobalLoader;